<div class="w-100 mx-auto search-input">
  <div class="mx-auto h-100 rounded-2 overflow-hidden position-relative bg-white border">
    <div class="mx-auto h-100 d-flex align-items-stretch justify-content-between py-2">
      <div *ngIf="prefixIcon !== ''" class="d-flex align-items-center justify-content-center ps-2">
        <mat-icon class="large">{{ prefixIcon }}</mat-icon>
      </div>
      <div class="bg-transparent h-100 w-100">
        <div class=""
             [ngClass]="{ 'px-3': prefixIcon === '', 'ps-1 pe-3': prefixIcon !== '', 'focused': focused || (value !== '' && value != null), 'nsi-nottall': !fixedHeight, 'nsi': fixedHeight, 'opacity-50': disabled }"
             (click)="FocusElement()">
          <div *ngIf="!changingPlaceholder" for="#{{ inputId }}-input" class="changing-text">
            <pla-text-changer [texts]="searchTexts" [customClasses]="'{{ customClasses }} fs-mb-11 fs-md-14 fw-light'"
                              [loopText]="true" [duration]="1.5"></pla-text-changer>
          </div>
          <div class="custom-input position-relative w-100">
            <input id="{{ inputId }}-input" style="color: transparent !important"
                   class="bg-transparent rounded-0 flex-fill border-0 py-0 px-0 m-0 w-100 {{ weight }} text-start"
                   [maxlength]="maxLength" [disabled]="disabled" (ngModelChange)="value = $event.toUpperCase()"
                   [ngModel]="value" (focus)="SetFocus(true)" (blur)="SetFocus(false)" (keydown)="KeyDown($event)">
            <span *ngIf="value !== '' && value != null" style="pointer-events: none; text-wrap: nowrap;"
                  class="custom-value position-absolute top-50 start-0 end-0 w-100 translate-middle-y {{ weight }}">{{value}}</span>

            <span *ngIf="!changingPlaceholder && (value === '' || value == null)"
                  style="pointer-events: none; text-wrap: nowrap;"
                  class="custom-placeholder position-absolute top-50 start-0 end-0 w-100 translate-middle-y {{ weight }}">{{placeholder}}</span>

            <span *ngIf="changingPlaceholder && (value === '' || value == null)"
                  style="pointer-events: none; text-wrap: nowrap;"
                  class="custom-placeholder position-absolute top-50 start-0 end-0 w-100 translate-middle-y {{ weight }}">
                    <pla-text-changer [texts]="searchTexts"
                                      [customClasses]="customChangerClasses + ' ' + weight + ' ' + (focused || (value !== '' && value != null) ? 'opacity-50' : '')"
                                      [loopText]="true" [duration]="1.5"></pla-text-changer>
                </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
